import React, { useEffect, useCallback, useState} from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import Dropdown from 'react-dropdown';
import {
    STAY,
    FORWARD,
    REVERSE,
    FORWARD_REVERSE,
    BROWNIAN
} from 'constants/scene-algorithms.js';
import {connect} from 'react-redux';

const NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', "J", "K", "L", "M", "N"];

const SceneDetails = ({currentScene, sequencerEngine}) => { 
    if (!currentScene) {
        return [];
    }
    return (
        <div className="scene-details">
        {sequencerEngine.subSequences.map(
            (subSequence, i) =>
                <SubSequenceDetails
                  i={i}
                  subSequence={subSequence}
                  scene={currentScene}/>)}
        </div>);
}

const OPTIONS = [
    {label: "Stay", value: STAY},
    {label: "Forward", value: FORWARD},
    {label: "Reverse", value: REVERSE},
    {label: "Brownian", value: BROWNIAN},
];

const SubSequenceDetails = ({i, scene, subSequence}) => {
    let [durationPercentage, setDurationPercentage] = useState(scene.durationPercentages[i]);
    let [algorithmType, setAlgorithmType] = useState(scene.algorithmTypes[i]);
    let [pattern, setPattern] = useState(scene.patterns[i]);

    useEffect(() => {
        setPattern(scene.patterns[i]);
        setDurationPercentage(scene.durationPercentages[i]);
        setAlgorithmType(scene.algorithmTypes[i]);
    }, [i, scene, setPattern, setAlgorithmType, setDurationPercentage]);

    const onChangeAlgorithm = useCallback((opt) => {
        scene.algorithmTypes[i] = opt.value;
        setAlgorithmType(opt.value);
    }, [setAlgorithmType, i, scene]);

    const onChangeDurationPercentage = useCallback((dur) => {
        scene.durationPercentages[i] = dur;
    }, [setDurationPercentage, i, scene]);

    const onChangePattern = useCallback((opt) => {
        scene.patterns[i] = opt.value;
        setPattern(opt.value);
    }, [setPattern, i, scene]);

    let patterns = subSequence.tracks[0] ?
        subSequence.tracks[0].patterns : [];

    const patternOptions = patterns.map(
        (pat, i) => ({
            label: "Pattern " + (i + 1),
            value: i
        }));


    let name = NAMES[i];
    return (
        <div className="sub-sequence-details">
          <div className="sub-name">
            {name}:
          </div>
          <Dropdown
            controlClassName="pattern-dropdown"
            options={patternOptions}
            onChange={onChangePattern}
            value={patternOptions.find(opt => opt.value === pattern)}
            placeholder="Pattern"
          />
          <Dropdown
            options={OPTIONS}
            onChange={onChangeAlgorithm}
            value={OPTIONS.find(x => algorithmType === x.value)}
            placeholder="Algo Type" />
       </div>
   );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SceneDetails);
